import { gql } from '../../../generated/graphql/index.js';

export const GET_ACCESS_DIRECTORY = gql(`
  query GetAccessDirectory {
    me {
      id
      roleNames
      grantingRoles {
        permission
        roleNames
        roleCount
      }
    }
    accessAdmins {
      id
      firstName
      lastName
      email
    }
  }
`);
